import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash';

interface FloPreviewsStateType {
	data: { [key: string]: unknown };
	loaded: boolean;
}

const initialState = Object.freeze({
	data: {},
	loaded: false,
});

const FloPreviewReducers = {
	setFloPreviews(state: FloPreviewsStateType, { payload }: { payload: { [key: string]: unknown } }) {
		state.data = payload;
		state.loaded = true;
	},
	getFloPreviews(state: FloPreviewsStateType, { payload }: { payload: string }) {},
	lookupFloPreview(state: FloPreviewsStateType, { payload }: { payload: string }) {},
	updateFloInPreview(state: FloPreviewsStateType, { payload }: { payload: { [key: string]: unknown } }) {
		state.data = set(state.data, payload.id, payload);
	},
	leaveFloPreviews(state: FloPreviewsStateType, { payload }: { payload: string }) {
		state.loaded = false;
	},
};

export const FloPreviews = createSlice({
	name: 'FloPreview',
	initialState,
	//@ts-ignore
	reducers: FloPreviewReducers,
});

export const setFloPreviews = FloPreviews.actions.setFloPreviews;
export const getFloPreviews = FloPreviews.actions.getFloPreviews;
export const lookupFloPreview = FloPreviews.actions.lookupFloPreview;
export const leaveFloPreviews = FloPreviews.actions.leaveFloPreviews;
export const updateFloInPreview = FloPreviews.actions.updateFloInPreview;

export default FloPreviews.reducer;
